import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import { IssueReportGet } from "../../../../models/IssueReport"
import { getNiceFormattedDate } from "../../../../utils/getFormattedDate"

export function IssueReportDetails(props: { readonly issueReport: IssueReportGet }) {
  const { issueReport } = props

  const detailsContentProps: DiMaDetailsContentProps = {
    inlineEdit: false,
    listItems: [
      {
        id: 0,
        label: "Application",
        displayItem: <div className="title">{issueReport.application.name}</div>,
      },
      {
        id: 1,
        label: "Topic",
        displayItem: <div className="title">{issueReport.topic.name}</div>,
      },
      {
        id: 2,
        label: "Subject",
        displayItem: <div className="title">{issueReport.subject}</div>,
      },
      {
        id: 3,
        label: "Message",
        displayItem: (
          <div
            className="title"
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              width: "100%",
              display: "block",
            }}
          >
            {issueReport.message}
          </div>
        ),
      },
      {
        id: 4,
        label: "Version",
        displayItem: <div className="title">{issueReport.version}</div>,
      },
      {
        id: 5,
        label: "Operating System",
        displayItem: <div className="title">{issueReport.operatingSystem}</div>,
      },
      {
        id: 6,
        label: "User Is Logged",
        displayItem: <div className="title">{issueReport.userIsLogged}</div>,
      },
      {
        id: 7,
        label: "User Role",
        displayItem: <div className="title">{issueReport.userRole}</div>,
      },
      {
        id: 8,
        label: "User Email",
        displayItem: <div className="title">{issueReport.userEmail}</div>,
      },
      {
        id: 9,
        label: "Domain Machine Name",
        displayItem: <div className="title">{issueReport.domainMachineName}</div>,
      },
      {
        id: 10,
        label: "Device Is Connected",
        displayItem: <div className="title">{issueReport.deviceIsConnected}</div>,
      },
      {
        id: 11,
        label: "Device Slave ID",
        displayItem: <div className="title">{issueReport.deviceSlaveId}</div>,
      },
      {
        id: 12,
        label: "Device Descriptor Name",
        displayItem: <div className="title">{issueReport.deviceDescriptorName}</div>,
      },
      {
        id: 13,
        label: "Creation date",
        displayItem: (
          <div className="title">{getNiceFormattedDate(issueReport.creationDate)}</div>
        ),
      },
      {
        id: 14,
        label: "Completed By",
        displayItem: <div className="title">{issueReport.completedBy?.username}</div>,
      },
      {
        id: 15,
        label: "Completion Date",
        displayItem: (
          <div className="title">
            {issueReport.completionDate
              ? getNiceFormattedDate(issueReport.completionDate)
              : ""}
          </div>
        ),
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
